
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class YqcrTable extends Vue {
    //一拳超人
    table = {
        data: [],
        column: [
            {
                title: '玩家ID',
                key: 'Bet',
                align: 'center',
                minWidth: 80,
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                title: '擂主',
                key: 'Bet',
                align: 'center',
                render: (h, params) => {
                    return h('span', params.row.banker == params.row.uid ? '是' : '否')
                }
            },
            {
                title: '底注金额',
                key: 'BasePoint',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.BasePoint))
                }
            },
            {
                title: '跟注金额',
                key: 'BetList',
                align: 'center',
                render: (h, params) => {
                    let list = JSON.parse(JSON.stringify(params.row.data.BetList))
                    let data = list.slice(1) || []
                    let str = ''
                    data.map((item) => {
                        str += (this as any).getMoney(item) + '、'
                    })
                    return h('span', str.substring(0, str.length - 1))
                }
            },
            {
                title: '下注金额',
                key: 'Bet',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.Bet))
                }
            },
            {
                title: '税收金额',
                key: 'PercentPoin',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.PercentPoin))
                }
            },
            {
                title: '输赢金额',
                key: 'RealAWard',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.RealAWard))
                }
            },
            {
                title: '退还金额',
                key: 'ReturnPoint',
                align: 'center',
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.ReturnPoint))
                }
            },
            {
                title: '对局胜负',
                key: 'Bet',
                align: 'center',
                minWidth: 120,
                render: (h, params) => {
                    let arr = ['剪刀', '石头', '布']
                    let str = ''
                    let data = JSON.parse(JSON.stringify(params.row.list)) || []
                    data.map((item) => {
                        let chuQ = arr[item.GuessHits[params.row.uid] - 1]
                        if (item.WinUid == 0) {
                            str += '平' + '（' + chuQ + '）' + '/ '
                        } else {
                            let winU = Number(item.WinUid) == Number(params.row.uid) ? '胜' : '负'
                            str += winU + '（' + chuQ + '）' + '/ '
                        }
                    })
                    return h('span', str.substring(0, str.length - 2))
                }
            }
        ]
    }
    getListData() {
        if (this.listdata[0].opt_detail == 'null') {
            return (this.table.data = [])
        } else {
            let obj = JSON.parse(this.listdata[0].opt_detail).users
            let list = JSON.parse(this.listdata[0].opt_detail)
            let arr: any = []
            for (let i in obj) {
                let obj1 = {
                    user_id: this.listdata[0].user_id,
                    uid: i,
                    banker: list.banker, //庄家ID
                    data: obj[i],
                    list: list.guess_result //猜拳结果
                }
                arr.push(obj1)
            }
            return arr
        }
    }

    @Prop()
    listdata
}
